var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudiomackLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Audiomack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 42,
    fill: "#111111"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 126c6 0 10-4 10-10s-4-10-10-10s-10 4-10 10s4 10 10 10zm18-5        c7-1 11-4 15-9l8-12c1-2 4-2 5 0l7 22c1 4 6 5 9 2l16-19c2-2 5-1 5 1l6 41        c1 5 8 7 11 3l23-37c2-3 7-2 7 2l8 72c1 6 8 8 12 3l22-126c1-6 7-9 12-8        c5 1 9 6 8 12l-15 91c-1 5 4 8 8 5l10-6c6-4 13 1 13 8c0 5-3 8-7 10l-19 11        c-5 3-12 0-13-6l-4-36c-1-5-7-7-10-2l-20 48c-4 8-15 7-17-2l-7-52c-1-5-7-7-10-2        l-19 28c-4 6-12 5-15-2l-9-22c-2-4-7-5-10-2l-11 10c-6 6-13 9-25 9c-6 0-10-4-10-10        s4-10 10-10z",
    fill: "#ffa10a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudiomackLogo);
export default __webpack_public_path__ + "static/media/audiomack-logo.dea56077bd46c982a3f43a81a73af53a.svg";
export { ForwardRef as ReactComponent };